import { IReducerAction } from '../../interfaces/IRedux'
import { AUTH_LOADING, AUTH_END_LOADING, AUTH_CLEAR, AUTH_GET_DATA } from '../types'

const initialState = {
    loading: false,
    isLoggedIn: false,
    user: {}
}

export default function reducer(state = initialState, action: IReducerAction) {
    const payload = action.payload || {}

    switch (action.type) {
        case AUTH_LOADING:
            return {
                ...state,
                loading: true
            }

        case AUTH_END_LOADING:
            return {
                ...state,
                loading: false
            }

        case AUTH_GET_DATA:
            return {
                ...state,
                loading: false,
                user: payload,
                isLoggedIn: Object.keys(payload).length > 0
            }

        case AUTH_CLEAR:
            return initialState
        default:
            return state
    }
}